import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import wallet from "@assets/icons/wallet.svg";
import coin from "@assets/icons/trading.svg";
import history from "@assets/icons/history.svg";
import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import Screen from "@/src/components/Screen";
import { Card } from "@/src/components/shad/card";
import coinbag from "@assets/icons/moneybag.svg";
import withdraw from "@assets/icons/withdraw.svg";
import deposit from "@assets/icons/deposit.svg";
import convert from "@assets/icons/convert.svg";
import transfer from "@assets/icons/transfer.svg";
import useUrlState from "@/src/hooks/use-url-state";
import { useAppSelector } from "@/src/app/hooks";
import CountUp from "react-countup";
import { Modal } from "@/src/components/Modal/Modal";
import Transfer from "./Forms/Transfer";
import { useTranslation } from "react-i18next";

const Wallet = () => {
  const [, setModal] = useUrlState("modal");
  const { total_spot_balance, total_funding_balance } = useAppSelector(
    (state) => state.user
  );
  const [open, setOpen] = useUrlState("modal");
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.wallet.${key}`);
  const routes = [
    {
      name: trans("sidebar.overview"),
      href: "",
      icon: wallet,
    },
    {
      name: trans("sidebar.trading"),
      href: "trading",
      icon: coin,
    },
    {
      name: trans("sidebar.history"),
      href: "history",
      icon: history,
    },
    // {
    //     name: 'Orders',
    //     href: 'orders',
    //     icon: bill
    // },
  ];
  return (
    <div className="grid lg:grid-cols-12">
      <div className="hidden lg:flex flex-col gap-4 col-span-2 mt-4 pr-3">
        {routes.map((item, index) => (
          <NavLink
            end
            className={({ isActive }) =>
              cn(
                "pl-4 py-2 flex items-center gap-2",
                textVariants({ variant: isActive ? "link" : "desc" }),
                isActive &&
                  "bg-[#E7EDF7] dark:bg-grey-500 rounded-r-md border-l-4 border-[#2F60E0]"
              )
            }
            to={item?.href}
            key={index}
          >
            {" "}
            <img src={item?.icon} alt="icon" className="h-5 w-5" />{" "}
            <span>{item?.name}</span>
          </NavLink>
        ))}
      </div>
      <div className="lg:hidden flex space-x-5 w-full col-span-12  items-center px-4">
        {routes.map((item, index) => (
          <NavLink
            end
            className={({ isActive }) =>
              cn(
                " py-2 flex items-center gap-2",
                textVariants({ variant: isActive ? "link" : "header" })
              )
            }
            to={item?.href}
            key={index}
          >
            {/* <img src={item?.icon} alt="icon" className="h-5 w-5" /> */}
            <span>{item?.name}</span>
          </NavLink>
        ))}
      </div>
      <div className="lg:col-span-10 col-span-12">
        <Screen>
          {pathname !== "/app/wallet/history" && (
            <div className=" grid grid-cols-1 lg:grid-cols-4 lg:gap-5 space-y-5 lg:space-y-0">
              {/* <div className="lg:col-span-1"> */}
              <Card className="p-4 rounded-2xl lg:col-span-1">
                <div className="flex items-center gap-1">
                  <img src={coinbag} className="h-10 w-10" alt="coin bag" />
                  <div className="flex flex-col gap-1">
                    <span
                      className={textVariants({ size: "sm", variant: "desc" })}
                    >
                      {trans("balance.header")}
                    </span>
                    <span
                      className={textVariants({ size: "xl", font: "semibold" })}
                    >
                      ${" "}
                      {pathname === "/app/wallet/trading" ? (
                        <CountUp
                          end={Number(total_funding_balance)}
                          start={0}
                          duration={1.5}
                          decimal="."
                          decimals={2}
                        />
                      ) : (
                        <CountUp
                          end={Number(total_spot_balance)}
                          start={0}
                          duration={1.5}
                          decimal="."
                          decimals={2}
                        />
                      )}
                    </span>
                  </div>
                </div>
              </Card>
              {/* </div> */}
              <div className="col-span-3 grid grid-cols-2 md:grid-cols-4 md:gap-4 gap-2 rounded-2xl bg-[#EDF0FA] dark:bg-grey-600 p-2 md:p-4">
                <Link to={"funding"}>
                  <Card className="px-4 py-2 rounded-2xl flex items-center gap-1">
                    <img src={deposit} className="h-10 w-10" alt="" />
                    <div
                      className={textVariants({ size: "lg", font: "medium" })}
                    >
                      {trans("cards.deposit")}
                    </div>
                  </Card>
                </Link>
                <Link to={"funding/withdraw"}>
                  <Card className="px-4 py-2 rounded-2xl flex items-center gap-1">
                    <img src={withdraw} className="h-10 w-10" alt="" />
                    <div
                      className={textVariants({ size: "lg", font: "medium" })}
                    >
                      {trans("cards.withdraw")}
                    </div>
                  </Card>
                </Link>
                <Link to={"funding/convert"}>
                  <Card className="px-4 py-2 rounded-2xl flex items-center gap-1">
                    <img src={convert} className="h-10 w-10" alt="" />
                    <div
                      className={textVariants({ size: "lg", font: "medium" })}
                    >
                      {trans("cards.convert")}
                    </div>
                  </Card>
                </Link>
                <Card
                  onClick={() => setModal("transfer")}
                  className="px-4 py-2 rounded-2xl flex items-center gap-1 cursor-pointer"
                >
                  <img src={transfer} className="h-10 w-10" alt="" />
                  <div className={textVariants({ size: "lg", font: "medium" })}>
                    {trans("cards.transfer")}
                  </div>
                </Card>
              </div>
            </div>
          )}
          <Outlet />
        </Screen>
      </div>
      <Modal
        open={open === "transfer"}
        setOpen={(val) => setOpen(val ? undefined : "transfer")}
        title="Transfer"
      >
        <Transfer />
      </Modal>
    </div>
  );
};

export default Wallet;
